import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackCheckout } from 'Helpers/Tracking';

import { isBrowser } from 'Helpers/Browser';
import { isProfile } from 'Helpers/User';
import { redirect } from 'Helpers/Uri';
import { calculateCartItemsPrice } from 'Helpers/Cart';
import { getRouteByName } from 'Helpers/Routes';

import Head from 'Components/helpers/Head';
import ItemsList from 'Components/public/cart/ItemsList';
import SummaryPanel from 'Components/public/cart/SummaryPanel';
import PackagesPanel from 'Components/public/cart/PackagesPanel';
import CreditsModal from 'Components/public/cart/CreditsModal';
import StickyBar from 'Components/public/cart/StickyBar';
import Button from 'Components/layout/Button';

import { me } from 'Redux/actions/user';
import { removeItem, loadItemPhoto, setSelectedPackage } from 'Redux/actions/cart';
import { purchaseByCredits } from 'Redux/actions/payments';
import { fetchCreditPackages } from 'Redux/actions/creditPackages';
import { addPhotos } from 'Redux/actions/downloads';

@connect(
    (state) => ({
        user: state.user,
        cart: state.cart,
        creditPackages: state.creditPackages,
        photos: state.photos,
        purchasePhotosPolicy: state.user.currentPolicies.purchasePhotos
    }), { me, loadItemPhoto, removeItem, fetchCreditPackages, setSelectedPackage, purchaseByCredits, addPhotos }
)
export default class Cart extends React.Component {
    static propTypes = {
        purchasePhotosPolicy: PropTypes.bool.isRequired,
        me: PropTypes.func.isRequired,
        loadItemPhoto: PropTypes.func.isRequired,
        removeItem: PropTypes.func.isRequired,
        fetchCreditPackages: PropTypes.func.isRequired,
        setSelectedPackage: PropTypes.func.isRequired,
        purchaseByCredits: PropTypes.func.isRequired,
        addPhotos: PropTypes.func.isRequired,
        user: PropTypes.shape({
            accessToken: PropTypes.string,
            currentBrandId: PropTypes.string,
            profile: PropTypes.shape({
                creditsCount: PropTypes.number
            })
        }).isRequired,
        cart: PropTypes.shape({
            isSyncing: PropTypes.bool.isRequired,
            isPricePending: PropTypes.bool.isRequired,
            items: PropTypes.array.isRequired,
            totalPrice: PropTypes.number.isRequired,
            creditsPrice: PropTypes.number.isRequired,
        }).isRequired,
        creditPackages: PropTypes.shape({
            isFetchPending: PropTypes.bool.isRequired,
            packages: PropTypes.array
        }).isRequired,
        photos: PropTypes.shape({
            photos: PropTypes.objectOf(
                PropTypes.shape({
                    single: PropTypes.shape({
                        isPending: PropTypes.bool.isRequired,
                        photo: PropTypes.shape({
                            id: PropTypes.string.isRequired,
                            selectedCaption: PropTypes.string,
                            price: PropTypes.number,
                            width: PropTypes.number,
                            height: PropTypes.number,
                            license: PropTypes.string,
                            resolutions: PropTypes.shape({
                                w640: PropTypes.string.isRequired
                            })
                        })
                    })
                })
            )
        })
    };
    static defaultProps = {};

    state = {
        isByCreditsPaymentPending: false,
        enterEventTracked: false,
        creditsModalVisible: false,
        errors: [],
        items: this.props.cart.items,
        promoCreditPackage: null,
        selectedPackage: null,
        selectedPackageId: ''
    };

    componentDidMount = () => {
        this.setItems(this.props);
        this.fetchCreditPackages();
        this.props.setSelectedPackage(null);

        if (this.props.user.accessToken) {
            this.props.me();
        }
    }

    componentWillReceiveProps = props => {
        this.setItems(props);

        if (isBrowser() && props.cart.items.length && !this.state.enterEventTracked) {
            trackCheckout('cartPageview', props.cart.items);
            this.stateenterEventTracked = true;
        }

        if (!props.purchasePhotosPolicy) {
            redirect(getRouteByName('market').path);
        }
    }

    fetchCreditPackages = () => {
        this.props.fetchCreditPackages();
    }

    setItems = props => {
        const { photos } = props.photos;
        let { items } = props.cart;
        let newItems = [];

        //check all photos if they have all data needed
        newItems = items.map((item, itemIndex) => {
            if (item && item.id && !this.hasItemData(item)) {
                if (!item.loading) {
                    props.loadItemPhoto(item.id);
                }

                return { ...item, loading: true };
            } else {
                return item;
            }
        });

        this.setState({
            ...this.state,
            items: newItems
        });
    }

    hasItemData = item => {
        const requiredItemFields = ['id', 'caption', 'curatedCaption', 'suggestedCaption', 'price', 'width', 'height', 'license', 'resolutions'];

        let result = true;
        requiredItemFields.map(field => {
            if (!item.hasOwnProperty(field)) {
                result = false;
            }
        });

        return result;
    }

    onRemoveItem = item => {
        this.props.removeItem(item);
    }

    onCreditPackageSelect = creditPackage => {
        let creditPackageId = '';

        //Check if creditPackage object has been send
        if (typeof creditPackage !== 'undefined') {

            //If yes, check if object have id
            if (typeof creditPackage.id !== 'undefined' && creditPackage.id) {
                creditPackageId = creditPackage.id;
            } else {
                //If no, set to no package
                creditPackageId = '';
            }
        } else if (this.state.selectedPackageId) {
            //If no, check if credit package is in state and set it
            creditPackageId = this.state.selectedPackageId;
        }

        //Reset credit package if user can't buy more credits right now
        let creditsCount = 0;
        if (this.props.user.profile && this.props.user.profile.hasOwnProperty('creditsCount') && !isNaN(this.props.user.profile.creditsCount)) {
            creditsCount = this.props.user.profile.creditsCount;
        }

        if (creditsCount && this.props.cart.creditsPrice < creditsCount) {
            creditPackageId = '';
        }

        this.props.setSelectedPackage(creditPackage || null, 'default', 'cart');
        setTimeout(() => {
            this.setState({
                ...this.state,
                selectedPackage: creditPackage,
                selectedPackageId: creditPackageId
            });
        }, 200);
    }

    onCheckout = () => {
        if (this.props.creditPackages.packages && !this.state.selectedPackageId) {
            if (isProfile() && this.props.user.profile.creditsCount) {
                redirect(getRouteByName('payment').path);
            }

            let itemsPrice = calculateCartItemsPrice(this.props.cart.items);

            let promoCreditPackage = null;
            this.props.creditPackages.packages.forEach(creditPackage => {
                if (creditPackage.price > itemsPrice && !promoCreditPackage) {
                    promoCreditPackage = creditPackage;
                }
            });

            if (promoCreditPackage && Object.keys(promoCreditPackage).length) {
                this.setState({
                    ...this.state,
                    promoCreditPackage: promoCreditPackage,
                    creditsModalVisible: true
                });
            } else {
                redirect(getRouteByName('payment').path);
            }
        } else {
            redirect(getRouteByName('payment').path);
        }
    }

    onSubmit = () => {
        this.setState({
            ...this.state,
            isByCreditsPaymentPending: true
        });

        this.props.purchaseByCredits()
            .then(response => {
                const payload = response.payload.data.purchaseCartByCredits;
                if (payload.errors && payload.errors.length) {
                    this.setState({
                        ...this.state,
                        errors: payload.errors
                    });
                } else {
                    this.props.addPhotos(payload.purchase.photos, null)
                        .then(response => {
                            redirect(getRouteByName('download').path);
                        });
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    errors: error
                });
            });
    }

    onHideCreditsModal = () => {
        this.setState({
            ...this.state,
            creditsModalVisible: false
        });
    }


    render() {
        const { isFetchPending, packages } = this.props.creditPackages;
        const { isSyncing, isPricePending, totalPrice, creditsPrice } = this.props.cart;
        const { profile, currentBrandId } = this.props.user;
        const { items, selectedPackageId, creditsModalVisible, promoCreditPackage, isByCreditsPaymentPending } = this.state;

        let creditsCount = 0;
        if (profile && profile.hasOwnProperty('creditsCount') && !isNaN(profile.creditsCount)) {
            creditsCount = profile.creditsCount;
        }

        let showPackages = false;
        if (!isFetchPending && (creditsCount === 0 || (creditsCount > 0 && totalPrice > 0))) {
            showPackages = true;
        }

        return (
            <div className="container-cart">
                <Head
                    title={`Your cart`}
                    description={``}
                    canonical={getRouteByName('cart').path}
                    robots={`noindex, nofollow`}
                />
                <StickyBar
                    isLoading={isSyncing || isPricePending}
                    isBrand={currentBrandId ? true : false}
                    items={items}
                    totalPrice={totalPrice}
                    creditsPrice={creditsPrice}
                    onCheckout={this.onCheckout}
                    onSubmit={this.onSubmit}
                />
                <CreditsModal
                    visible={creditsModalVisible}
                    onHideDemoModal={this.onHideCreditsModal}
                    onSelect={this.onCreditPackageSelect}
                    selectedPackageId={selectedPackageId}
                    creditPackage={promoCreditPackage}
                    cart={this.props.cart}
                />
                <div className="container-fluid">
                    <header className="cart-header-header">
                        <h1 className="cart-header-headline">{isSyncing ? `Your cart is loading...` : `Your Cart (${items.length} images)`}</h1>
                    </header>
                    {this.state.errors && this.state.errors.length ?
                        <div className="cart-errors-panel">
                            <h3 className="cart-error-headline">Your Purchase couldn't be processed</h3>
                            {this.state.errors.map(error => {
                                return (<p key={error.message} className="cart-error-message">{error.message}</p>);
                            })}
                        </div>
                        : null}
                    <ItemsList
                        isLoading={isSyncing}
                        hidePrices={currentBrandId ? true : false}
                        items={items}
                        onRemoveItem={this.onRemoveItem}
                    />
                    <aside>
                        <div className="sticky-container">
                            <SummaryPanel
                                isLoading={isSyncing || isPricePending || isByCreditsPaymentPending}
                                isBrand={currentBrandId ? true : false}
                                items={items}
                                totalPrice={totalPrice}
                                creditsPrice={creditsPrice}
                                selectedPackageId={selectedPackageId}
                                creditsCount={creditsCount}
                                onSelect={this.onCreditPackageSelect}
                                onSubmit={this.onSubmit}
                            />
                            {!currentBrandId && totalPrice && items.length ?
                                <PackagesPanel
                                    isLoading={isFetchPending}
                                    visible={showPackages && !currentBrandId}
                                    items={items}
                                    totalPrice={totalPrice}
                                    selectedPackageId={selectedPackageId}
                                    packages={packages}
                                    onSelect={this.onCreditPackageSelect}
                                    onSubmit={this.onSubmit}
                                />
                                : null}
                            {!currentBrandId && totalPrice && items.length ?
                                <div className="main-cta">
                                    <Button
                                        id="btn-checkout"
                                        className="btn-currency"
                                        element="anchor"
                                        layout="full-width"
                                        onClick={this.onCheckout}
                                    >
                                        Proceed to checkout
                                    </Button>
                                </div>
                                : null}
                        </div>
                    </aside>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Cart/index.js